import lazySizes from 'lazysizes';

// use .lazy instead of .lazyload
lazySizes.cfg.lazyClass = 'lazy';

// use data-original instead of data-src
lazySizes.cfg.srcAttr = 'data-original';
